import { Control, FormType } from './add-website-dialog.models';

export const TYPES = [
  {
    label: 'Site',
    value: FormType.SITE.toString(),
  },
  {
    label: 'Main',
    value: FormType.MAIN_SITE.toString(),
  },
  {
    label: 'Alias',
    value: FormType.ALIAS.toString(),
  },
  {
    label: 'Subdomain',
    value: FormType.SUBDOMAIN.toString(),
  },
];

export const SITE_CONTROLS: Control[] = [
  {
    label: 'Server',
    placeholder: 'Select server',
    type: 'autocomplete',
    options: [],
    controlName: 'originServer',
    errors: {
      required: 'Server is required',
    },
  },
  {
    label: 'Group',
    placeholder: 'Select group',
    type: 'autocomplete',
    options: [],
    controlName: 'groupId',
    errors: {
      required: 'Group is required',
    },
  },
  {
    label: 'Website',
    placeholder: 'Enter website',
    type: 'text',
    controlName: 'domain',
    errors: {
      required: 'Website is required',
      invalidDomain: 'Invalid domain',
    },
  },
  {
    label: 'Enable Email Service',
    type: 'checkbox',
    controlName: 'enableEmail',
    errors: {},
  },
  {
    label: 'Install WordPress',
    type: 'checkbox',
    controlName: 'installWordpress',
    errors: {},
  },
];

export const MAIN_SITE_CONTROLS: Control[] = [
  {
    label: 'Server',
    placeholder: 'Select server',
    type: 'autocomplete',
    options: [],
    controlName: 'originServer',
    errors: {
      required: 'Server is required',
    },
  },
  {
    label: 'Owner',
    placeholder: 'Select user',
    type: 'autocomplete',
    options: [],
    controlName: 'userId',
    errors: {
      required: 'Owner is required',
    },
  },

  {
    label: 'Plan',
    placeholder: 'Select plan',
    type: 'select',
    options: [],
    controlName: 'plan',
    errors: {
      required: 'Plan is required',
    },
  },
  {
    label: 'Main Website',
    placeholder: 'Enter website',
    type: 'text',
    controlName: 'domain',
    errors: {
      required: 'Website is required',
      invalidDomain: 'Invalid domain',
    },
  },
  {
    label: 'Enable Email Service',
    type: 'checkbox',
    controlName: 'enableEmail',
    errors: {},
  },
  {
    label: 'Install WordPress',
    type: 'checkbox',
    controlName: 'installWordpress',
    errors: {},
  },
];

export const ALIAS_CONTROLS: Control[] = [
  {
    label: 'Website',
    placeholder: 'Select website',
    type: 'autocomplete',
    options: [],
    controlName: 'websiteId',
    errors: {
      required: 'Website is required',
    },
  },
  {
    label: 'Alias',
    placeholder: 'Enter alias',
    type: 'text',
    controlName: 'domain',
    errors: {
      required: 'Alias is required',
      invalidDomain: 'Invalid domain',
    },
  },
  {
    label: 'Enable Email Service',
    type: 'checkbox',
    controlName: 'enableEmail',
    errors: {},
  },
];

export const SUBDOMAIN_CONTROLS: Control[] = [
  {
    label: 'Website',
    placeholder: 'Select website',
    type: 'autocomplete',
    options: [],
    controlName: 'websiteId',
    errors: {
      required: 'Website is required',
    },
  },
  {
    label: 'Subdomain',
    placeholder: 'Enter subdomain',
    type: 'text',
    controlName: 'domain',
    errors: {
      required: 'Subdomain is required',
      invalidDomain: 'Invalid domain',
    },
  },
  {
    label: 'Enable Email Service',
    type: 'checkbox',
    controlName: 'enableEmail',
    errors: {},
  },
  {
    label: 'Install WordPress',
    type: 'checkbox',
    controlName: 'installWordpress',
    errors: {},
  },
];

export const FORM_ERROR_MESSAGES: Record<string, Record<string, string>> = {
  originServer: {
    required: 'Server is required',
  },
  groupId: {
    required: 'Group is required',
  },
  websiteId: {
    required: 'Website is required',
  },
  domain: {
    required: 'Website is required',
    invalidDomain: 'Invalid domain',
  },
  userId: {
    required: 'Owner is required',
  },
  plan: {
    required: 'Plan is required',
  },
};

export const WP_FORM_ERROR_MESSAGES: Record<string, Record<string, string>> = {
  user: {
    required: 'Username is required',
  },
  password: {
    required: 'Password is required',
  },
  email: {
    required: 'Email is required',
    email: 'Invalid email',
  },
};
